module.exports = __webpack_public_path__ + "img/get-free-download1.003aa50b.png";